/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

import React from "react";

const Button = (props) => {
  return (
    <button
      // className={['button',props.className].join(' ')}
      className={[props.disableBaseClass ? "" : "button", props.className]
        .filter(Boolean)
        .join(" ")} //adding an opt-out prop to disable the default button stylling
      {...props.buttonProps}
      disabled={props.disabled}
      onClick={props.onClick}
      style={props.style}
    >
      {props.children}
    </button>
  );
};

export default Button;
